<template>
  <!-- 编辑回复模板 -->
  <div class="viewContent">
    <!-- 问卷测评结果 -->
    <l-dialog
      :show="isInfo"
      :isbtn="false"
      :ischa="true"
      @cancel="isInfo=false"
      class="msgDialog"
      title="问卷测评结果"
    >
      <div class="oneLeft">
        <h1>{{resultInfo.question_name}}</h1>
        <p class="tag">(包含{{childList.length}}分卷)</p>
        <div class="tab">
          <table>
            <tr>
              <th style="width:2.8rem">分卷名称</th>
              <th style="width:.9rem">得分</th>
              <th style="width:1.3rem">考试用时</th>
              <th style="width:1.4rem">操作</th>
            </tr>
            <tr v-for="(item,index) in childList" :key="index">
              <td style="text-align:left;padding-left:.2rem">{{item.title}}</td>
              <td>{{item.score}}</td>
              <td>{{Math.floor(item.spentTime/60)+'分'+Math.floor(item.spentTime%60)+'秒'}}</td>
              <td>
                <l-button value="查看" color="#3170FF" @click.native="handLookInfo(item)"></l-button>
                <div class="bad" v-show="item.unread==0"></div>
              </td>
            </tr>
          </table>
        </div>
        <p class="markTitle">—— 对本次问卷的整体点评 ——</p>
        <div class="eval">
          <el-input type="textarea" placeholder="请输入点评内容" v-model="mark"></el-input>
        </div>
      </div>
      <div class="right">
        <p class="tit">—— 用户资料 ——</p>
        <p>
          姓名：
          <span>{{resultInfo.userNickname}}</span>
        </p>
        <p>
          性别：
          <span>{{resultInfo.userSex}}</span>
        </p>
        <p>
          年龄：
          <span>{{resultInfo.userAge}}</span>
        </p>
        <p>
          部门：
          <span>{{resultInfo.userDeptname}}</span>
        </p>
        <p>
          编号：
          <span>{{resultInfo.userStudent}}</span>
        </p>
        <p>
          生成：
          <span>{{formatDate(info.finishTime)}}</span>
        </p>
        <div class="btn">
          <l-button value="删除" color="#3170FF" @click.native="delQuestion()"></l-button>
          <l-button value="关闭" @click.native="isInfo=false;getResult()"></l-button>
        </div>
      </div>
    </l-dialog>
    <!-- 分卷详情 -->
    <l-dialog
      :show="readShunt"
      :ischa="true"
      :isbtn="false"
      @save="operate(4)"
      @cancel="readShunt=false"
      class="recordLog"
      :title="'分卷：'+record.title"
      val1="确定"
    >
      <div class="ipt">
        <span class="label">测评人：</span>
        <el-input v-model="resultInfo.userNickname" placeholder="请输入内容" style="width:1.2rem"></el-input>
        <span class="label">所在部门：</span>
        <el-input v-model="resultInfo.userDeptname" placeholder="请输入内容" style="width:2rem"></el-input>
        <span class="label">编号：</span>
        <el-input v-model="resultInfo.userStudent" placeholder="请输入内容" style="width:.6rem"></el-input>
        <span class="label">本分卷考试用时：</span>
        <el-input v-model="spentTime" placeholder="请输入内容" style="width:1.2rem"></el-input>
      </div>
      <p class="score">
        测评得分：
        <span>{{record.score}}</span>
      </p>
      <ul>
        <li v-for="(item,index) in record.list" :key="index" class="topic">
          <p>{{index+1}}、【{{topicType[item.type-1]}}】{{item.questions}}。({{ item.type == 4 ? item.score*item.answer.length : item.score}}分)</p>
          <template v-if="item.type==1 || item.type==3">
            <el-radio-group v-model="answerRadio[index]">
              <div class="option" v-for="(answer,i) in item.answer" :key="i">
                <el-radio :label="answer.ucorrect">{{answer.answer}}</el-radio>
                <div
                  class="oper corr"
                  v-show="answer.is_correct == 1 && answer.ucorrect==1"
                  style="margin-top:-.05rem"
                >√正确</div>
                <div
                  class="oper mis"
                  v-show="answer.is_correct == 0 && answer.ucorrect==1"
                  style="margin-top:-.05rem"
                >×错误</div>
              </div>
            </el-radio-group>
          </template>
          <template v-else-if="item.type==2">
            <div class="option" v-for="(answer,i) in item.answer" :key="i">
              <el-checkbox v-model="answer.ucorrect" true-label="1">{{answer.answer}}</el-checkbox>
              <div
                class="oper corr"
                v-show="answer.is_correct == 1"
                style="margin-top:-.05rem"
              >√正确答案</div>
              <!-- <div
                class="oper corr"
                v-show="answer.is_correct == 1 && answer.ucorrect==1"
                style="margin-top:-.05rem"
              >√正确</div>
              <div
                class="oper mis"
                v-show="answer.is_correct == 0 && answer.ucorrect==1"
                style="margin-top:-.05rem"
              >×错误</div> -->
            </div>
          </template>
          <template v-else-if="item.type==4">
            <div class="option" v-for="(answer,i) in item.answer" :key="i">
              <span>①：</span>
              <p class="line">{{answer.uanswer}}</p>
              <div class="oper corr" v-show="answer.is_correct == 1">√正确</div>
              <div class="oper mis" v-show="answer.is_correct == 0">×错误</div>
              <div
                class="oper not"
                v-show="!answer.is_correct && answer.is_correct != 0"
                @click="isNots(index,i)"
              >
                <span>--</span>
                <ul v-show="nots[index][i]">
                  <li @click="oper(answer,1)">√正确</li>
                  <li @click="oper(answer,0)">×错误</li>
                </ul>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="option">
              <p class="msg">{{item.uanswer}}</p>
              <div class="ipt" style="margin-top:.3rem">
                <span class="label">本题得分：</span>
                <el-input
                  v-model="item.getScore"
                  placeholder="请输入内容"
                  style="width:1rem"
                  type="number"
                ></el-input>
                <span style="color:#777">分</span>
                <span style="margin-left:.2rem;color:#777">(满分{{item.score}}分)</span>
              </div>
              <ul class="lines">
                <li v-for="line in Math.ceil(item.uanswer.length / 60)" :key="line"></li>
              </ul>
            </div>
          </template>
          <div class="remark" v-show="!showRemarks[index]">
            <div class="dot"></div>
            <img src="../../../../assets/img/home/dp1.png" @click="isRemarks(index)" />
          </div>
          <div class="textremark" v-show="showRemarks[index]">
            <img src="../../../../assets/img/home/dp2.png" />
            <el-input type="textarea" placeholder="请输入点评内容" v-model="item.topic_results"></el-input>
          </div>
        </li>
      </ul>
      <p style="text-align:center;margin:.49rem 0 .19rem 0">—— 对本套问卷的点评 ——</p>
      <div class="overall">
        <div class="admininfo">
          <img :src="global.ip + record.avatar" />
          <div>
            <p>{{record.nickname}}(管理员)点评：</p>
            <p class="readtime">{{record.readTime}}</p>
          </div>
        </div>
        <div class="testResults">{{record.testResults}}</div>
      </div>
      <div class="btns">
        <l-button value="关闭" color="#EFBC00" @click.native="readShunt=false"></l-button>
      </div>
    </l-dialog>
    <!-- 内容 -->
    <div class="search">
      <p>您已完成过的问卷测评结果如下：</p>
      <div>
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="search">
          <template slot="append">
            <span @click="getResult({page: 1})">搜索</span>
          </template>
        </el-input>
      </div>
    </div>
    <div class="table">
      <div class="type">共有问卷测评结果：{{queryObj.total}}份</div>
      <table style="padding:0 .35rem" cellspacing="0">
        <tr>
          <th style="width:4rem" @click="scaleTh = !scaleTh">
            问卷名称
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="selectScale" :show.sync="scaleTh">
              <p :class="{'on':queryObj.sort == 'asc'}" @click="getResult({time:'',sort:'asc',})">按拼音（正序）</p>
              <p :class="{'on':queryObj.sort == 'desc'}" @click="getResult({time:'',sort:'desc',})">按拼音（倒序）</p>
            </eject-select-list>
          </th>
          <th style="width:1.8rem" @click="typeTh = !typeTh,getType()">
            问卷分类
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="selectType" :show.sync="typeTh">
              <p :class="{'on':queryObj.cid == ''}" @click="getResult({cid:'',page: 1})">全部</p>
              <p
                v-for="(item,index) in typeList"
                :key="index"
                :class="{'on':queryObj.cid == item.category_id}"
                @click="getResult({cid:item.category_id,page: 1})"
              >{{item.category_name}}</p>
            </eject-select-list>
          </th>
          <th style="width:1rem">包含分卷</th>
          <th style="width:1rem">发布人</th>
          <th style="width:2rem" @click="timeTh = !timeTh">
            结果生成日期
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="selectTime" :show.sync="timeTh">
              <l-date-picker v-model="queryObj.date" @change="getResult({page:1})"></l-date-picker>
              <!--<p @click="isDate=!isDate">选择日期范围</p>
              <div v-show="isDate" style="margin-top:.05rem">
                <div>
                  <el-input v-model="startDate" style="width:.9rem"></el-input>
                  <span style="margin:0 5px">-</span>
                  <el-input v-model="endDate" style="width:.9rem"></el-input>
                  <i
                    class="el-icon-search"
                    style="font-size:.18rem;margin-left:.05rem"
                    @click="getResult(),timeTh=false,startDate='',endDate=''"
                  ></i>
                </div>
                <Calendar
                  @choseDay="clickDay"
                  @changeMonth="changeDate"
                  :markDate="markDate"
                  ref="cale"
                />
              </div>-->
              <p :class="{'on':queryObj.time == 'asc'}" @click="getResult({time:'asc',sort:''})">按最远建立排序</p>
              <p :class="{'on':queryObj.time == 'desc'}" @click="getResult({time:'desc',sort:''})">按最近建立排序</p>
            </eject-select-list>
          </th>
          <th style="width:1.45rem" @click="statusTh = !statusTh">
            结果是否可查看
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="selectStatus" :show.sync="statusTh">
              <p :class="{'on':queryObj.status == ''}" @click="getResult({status:'',page: 1})">全部</p>
              <p :class="{'on':queryObj.status == 1}" @click="getResult({status:1,page: 1})">可查看</p>
              <p :class="{'on':queryObj.status == 2}" @click="getResult({status:2,page: 1})">不可查看</p>
            </eject-select-list>
          </th>
          <th style="width:2.35rem">操作</th>
        </tr>
        <tr v-for="(item) in resultList" :key="item.publishId" @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }">
          <td>
            <div class="td4">
              <img src="@/assets/img/home/wj.png" alt />
              {{item.questionName}}
            </div>
          </td>
          <td>{{item.categoryName}}</td>
          <td>{{item.testNum}}</td>
          <td>{{item.issuer}}</td>
          <td>{{formatDate(item.finishTime)}}</td>
          <td>{{item.isView==1 ? '可查看' : item.isView==2 ? '不可查看' : '待批阅'}}</td>
          <td>
            <l-button value="查看" color="#3170FF" v-if="item.isView==1" @click.native="handLook(item)"></l-button>
            <l-button value="不可查看" color="#FF500C" v-else></l-button>
            <l-button
              value="删除"
              color="#F0F0F0"
              style="color:#333333;margin-left:.15rem"
              @click.native="delQuestion(item)"
            ></l-button>
            <div class="dot" v-if="item.unread==0"></div>
          </td>
        </tr>
      </table>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="queryObj.total"
      :currentPage="queryObj.page"
      :page-size="queryObj.pageSize"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import lButton from "@/components/lButton.vue";
import lDialog from "@/components/lDialog.vue";
import { formatDate1 } from "../../../../assets/js/formatDate";
import { formatDate2 } from "@/utils/common/formatDate.js";
import Calendar from "vue-calendar-component";
export default {
  data() {
    return {
      nowClickRow: null,
      uid: JSON.parse(localStorage.getItem("userinfo")).uid,
      resultList: [],
      childList: [],
      typeList: [],
      scaleTh: false,
      typeTh: false,
      timeTh: false,
      statusTh: false,
      search: "",
      //详情
      isInfo: false,
      showResult: true,
      info: {},
      resultInfo: {},
      mark: "",
      //查看or批阅分卷
      spentTime: "",
      readShunt: false,
      recordId: "",
      record: {},
      nots: [], //填空题对否
      answerRadio: [], //单选框组
      showRemarks: [], //点评
      overall: "", //整体点评
      //分页
      page: 1,
      total: 0,
      topicType: ["单选题", "多选题", "判断题", "填空题", "问答题"],
      //日期
      isDate: false,
      startDate: "",
      endDate: "",
      markDate: [],

      queryObj: {
        sex: '',
        dept: '',
        cid: '',
        sort: '',
        date: [],
        time: '',
        status: '',
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    //获取结果列表
    async getResult(qObj = this.queryObj) {
      qObj = Object.assign(this.queryObj, qObj)
      let { data } = await this.$post(
        "api/admin/Testresult/searchQuestionResult",
        {
          page: qObj.page,
          pagesize: qObj.pageSize,
          search: this.search,
          startTime: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
          endTime: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
          sex: qObj.sex,
          deptid: qObj.dept,
          isView: qObj.status,
          title_desc: qObj.sort,
          time_desc: qObj.time,
          category_id: qObj.cid,
        }
      );
      console.log(data);
      this.checkAll = false;
      this.checkLists = [];
      this.resultList = data.data.list;
      this.queryObj.total = data.data.total;
    },
    //获取分类
    async getType() {
      let { data } = await this.$post(
        "api/admin/questionTest/getQuestionnaireCategory",
        { type: 1 }
      );
      this.typeList = data.data.list;
    },
    //查看
    async handLook(item) {
      this.isInfo = true;
      this.info = item;
      //获取子任务列表
      let { data } = await this.$post(
        "api/admin/Testresult/checkQuestionResult",
        {
          publishWhoId: item.publishWhoId,
        }
      );
      this.childList = data.data.list;
      this.resultInfo = data.data;
      this.mark = this.resultInfo.remark;
    },
    //查看or批阅
    async handLookInfo(item) {
      this.recordId = item.recordId;
      item.unread = 1
      if (item.isRead == 0) {
        let { data } = await this.$post(
          "api/admin/AdminTestresult/getAdminSubtest",
          {
            recordId: item.recordId,
          }
        );
        this.record = data.data;
      } else {
        let { data } = await this.$post("api/admin/Testresult/checkSubtest", {
          recordId: item.recordId,
        });
        this.record = data.data;
      }
      this.spentTime =
        Math.floor(this.record.spentTime / 60) +
        "分钟" +
        Math.floor(this.record.spentTime % 60) +
        "秒";
      console.log(this.record.spentTime)
      //单选框组
      this.answerRadio = Array.from(
        { length: this.record.list.length },
        () => "1"
      );
      //填空相关操作
      this.record.list.forEach((item, index) => {
        if (item.type == 4) {
          this.$set(
            this.nots,
            index,
            Array.from({ length: item.answer.length }, () => {
              return false;
            })
          );
        }
      });
      //点评显示隐藏
      this.showRemarks = Array.from({ length: this.record.list.length }, (item, index) => {
        return !!this.record.list[index].topic_results;
      });
      this.readShunt = true;
    },
    //选择填空题是否正确
    oper(answer, o) {
      this.$set(answer, "is_correct", o);
    },
    isNots(index, i) {
      this.$set(this.nots[index], i, !this.nots[index][i]);
    },
    //是否显示点评
    isRemarks(index) {
      this.$set(this.showRemarks, index, true);
    },
    //已读
    async setRead() {
      if (this.checkLists.length <= 0) {
        this.$myMessage("请先选择一个量表");
        return;
      }
      let ids = this.checkLists.map((item) => {
        return item.publishId;
      });
      await this.$post("api/test/getReadTable", {
        testType: 3,
        id: ids.toString(),
      });
      this.getResult();
    },
    //删除问卷
    delQuestion(item = this.info) {
      this.$popup({
        title: '提示',
        content: '确定删除所选数据？',
        saveFoo: () => {
          this.$post("api/admin/Testresult/delQuestionResult", {
            publishWhoId: item.publishWhoId,
          }).then(()=>{
            this.getResult();
            this.info = {};
            this.isInfo = false;
          })
        }
      })
    },
    //分页
    changePage(page) {
      this.queryObj.page = page;
      this.getResult();
    },
    //选择日期
    clickDay(val) {
      if (this.markDate.length < 2) {
        this.markDate.push(val);
      } else {
        if (new Date(val) > new Date(this.markDate[1])) {
          this.$set(this.markDate, 1, val);
        } else if (new Date(val) < new Date(this.markDate[0])) {
          this.$set(this.markDate, 0, val);
        } else {
          this.$set(this.markDate, 0, val);
          this.$set(this.markDate, 1, val);
        }
      }
      this.startDate = this.markDate[0];
      this.endDate = this.markDate[1];
    },
    changeDate(val) {
      console.log(val);
    },
    //日期格式转换
    formatDate(time) {
      return formatDate1(time);
    },
  },
  computed: {},
  mounted() {
    this.getResult();
  },
  components: {
    "l-button": lButton,
    "l-dialog": lDialog,
    Calendar,
  },
};
</script>

<style lang='less' scoped>
.viewContent {
  //弹出框
  /deep/.markDialog {
    height: 460px;
    width: 750px;
    z-index: 100;
    .content {
      padding: 41px 0 0 58px;
      .ipt {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        .el-radio-group {
          margin-top: 2px;
        }
        .el-input__inner,
        .el-textarea__inner {
          border: 0;
          background: #f0f0f0;
        }
      }
    }
  }
  //详情
  /deep/.msgDialog .dialog {
    width: 1000px;
    height: 750px;
    .content {
      display: flex;
    }
    .oneLeft {
      width: 719px;
      overflow-y: auto;
      border-right: 1px solid #f0f0f0;
      padding-left: 30px;
      box-sizing: border-box;
      h1 {
        padding-top: 27px;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        color: #333333;
      }
      .tag {
        font-size: 14px;
        text-align: center;
        color: #777;
        margin: 10px 0 26px 0;
      }
      .tab {
        max-height: 295px;
        overflow-y: auto;
      }
      table {
        font-size: 14px;
        border-collapse: collapse;
        text-align: center;
        th {
          background: #f7f7f7;
          height: 40px;
          color: #777777;
          font-weight: 400;
        }
        tr {
          position: relative;
        }
        td {
          height: 50px;
          color: #333333;
          border-bottom: 1px solid #f0f0f0;
          button {
            height: 32px;
            width: 60px;
          }
        }
        .bad {
          background: red;
          height: 8px;
          width: 8px;
          border-radius: 50%;
          position: absolute;
          top: 6px;
          right: 35px !important;
        }
      }
      .markTitle {
        text-align: center;
        color: #333333;
        margin: 28px 0 20px 0;
      }
      .eval {
        height: 160px !important;
        width: 640px;
        overflow: hidden;
        border: 1px solid #f0f0f0;
        border-radius: 10px;
        .el-textarea__inner {
          height: 160px;
          border: 0;
          background: #f0f0f0;
        }
        .el-checkbox__label {
          display: inline-block;
          color: #333;
        }
        .mark {
          position: relative;
          display: flex;
          margin-left: 250px;
          img {
            width: 16px;
          }
          .flot {
            position: absolute;
            top: -160px;
            left: -10px;
            width: 120px;
            height: 150px;
            overflow: auto;
            background: #ffffff;
            border-radius: 6px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
            li {
              height: 50px;
              line-height: 50px;
              text-align: center;
              border-bottom: 1px solid #f0f0f0;
              box-sizing: border-box;
              &:hover {
                background: #f0f0f0;
              }
            }
          }
        }
      }
    }
    .left {
      width: 719px;
      overflow-y: auto;
      border-right: 1px solid #f0f0f0;
      padding-left: 59px;
      box-sizing: border-box;
      .tit {
        color: #404040;
        padding-top: 39px;
      }
      .tag {
        color: #404040;
        margin-bottom: 25px;
      }
      .msg {
        font-size: 14px;
        color: #555555;
        line-height: 30px;
      }
    }
    .right {
      font-size: 14px;
      width: 280px;
      box-sizing: border-box;
      .tit {
        margin: 39px 0 29px 0;
        text-align: center;
        color: #5f5f5f;
      }
      p {
        margin-left: 30px;
        margin-bottom: 25px;
      }
      span {
        color: #555;
      }
      .btn {
        position: absolute;
        height: 40px;
        width: 240px;
        text-align: center;
        line-height: 40px;
        bottom: 50px;
        button {
          width: 70px;
          margin: 0 5px;
        }
      }
    }
  }
  /deep/.delLog {
    width: 350px;
    height: 240px;
    p {
      padding: 49px 0 24px 0;
      color: #333333;
      text-align: center;
    }
  }
  /deep/.recordLog .dialog {
    width: 1000px;
    height: 800px;
    .content {
      color: #333;
      padding: 30px 0 0 60px;
      font-size: 14px;
      overflow: auto;
      .ipt {
        .label {
          font-size: 14px;
          color: #333333;
        }
        .el-input {
          margin-right: 20px;
        }
        .el-input__inner {
          border: 0;
          background: #f0f0f0;
        }
      }
      .score {
        font-size: 14px;
        text-align: center;
        margin-top: 42px;
        span {
          display: inline-block;
          width: 80px;
          text-align: center;
          color: red;
          border-bottom: 1px solid #222222;
        }
      }
      ul {
        .el-radio__label {
          color: #333333;
        }
        .el-checkbox__label {
          display: inline-block;
          margin-right: 20px;
          color: #333;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #409eff;
        }
        .topic {
          margin-top: 35px;
        }
        li {
          .option {
            margin-top: 32px;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            .line {
              border-bottom: 1px solid #999;
              width: 220px;
              padding-left: 20px;
            }
            .msg {
              line-height: 62px;
              text-indent: 2em;
              width: 815px;
              color: #777777;
            }
            .oper {
              height: 24px;
              min-width: 50px;
              padding: 0 8px;
              box-sizing: border-box;
              border-radius: 12px;
              font-size: 12px;
              line-height: 24px;
              text-align: center;
            }
            .corr {
              background: #eaf0ff;
              color: #3170ff;
            }
            .mis {
              color: #fe0000;
              background: #ffe5e5;
            }
            .not {
              color: #555555;
              background: #eee;
              position: relative;
              ul {
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
                position: absolute;
                left: 60px;
                top: -20px;
                li {
                  height: 30px;
                  width: 60px;
                  line-height: 30px;
                  text-align: center;
                  font-size: 12px;
                  color: #333;
                  &:hover {
                    background: #f4f7ff;
                  }
                }
              }
            }
            .lines {
              position: absolute;
              li {
                border-bottom: 1px solid #aaa;
                width: 815px;
                height: 60px;
              }
            }
          }
          .tit {
            margin-top: 40px;
          }
        }
      }
      .remark {
        position: relative;
        width: 850px;
        height: 34px;
        border-bottom: 1px solid #f0f0f0;
        .dot {
          position: absolute;
          bottom: -5px;
          width: 10px;
          height: 10px;
          background: #ccc;
          border-radius: 50%;
        }
        img {
          position: absolute;
          right: 0;
          bottom: 0;
          height: 30px;
          width: 100px;
        }
      }
      .textremark {
        margin-top: 30px;
        background: #f0f0f0;
        width: 880px;
        height: 83px;
        border-radius: 10px;
        overflow: hidden;
        img {
          height: 30px;
          width: 100px;
          margin-left: 30px;
        }
        .el-textarea__inner {
          background: #f0f0f0;
          border: 0;
          padding-left: 50px;
        }
      }
      .btns {
        text-align: center;
        margin: 20px 0;
        button {
          margin: 0 10px;
        }
      }
    }
    .overall {
      background: #f0f0f0;
      .admininfo {
        display: flex;
        margin: 20px 0 0 30px;
        img {
          height: 50px;
          width: 50px;
          border-radius: 50%;
          margin-right: 20px;
        }
        .readtime {
          font-size: 14px;
          color: #999999;
          line-height: 36px;
        }
      }
      .testResults {
        margin-left: 100px;
        font-size: 14px;
        color: #777777;
        line-height: 36px;
      }
    }
  }

  .table {
    margin-top: 20px;
    height: 770px;
    width: 1430px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .type {
      height: 60px;
      line-height: 60px;
      color: #222222;
      background: #f0f0f0;
      text-align: center;
    }
    .grid {
      display: flex;
      .right {
        width: 175px;
        height: 570px;
        box-sizing: border-box;
        border-left: 1px solid #f0f0f0;
        padding-left: 28px;
        button {
          height: 40px;
          line-height: 40px;
          width: 110px;
          font-size: 14px;
          border-radius: 6px;
          margin-top: 16px;
        }
      }
    }
    table {
      font-size: 14px;
      .dot {
        position: absolute;
        top: 4px;
        left: 105px;
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 50%;
      }
      tr {
        height: 55px;
        text-align: center;
      }
      th {
        color: #555;
        font-weight: 400;
        position: relative;
        .el-checkbox {
          margin-right: 5px;
        }
      }
      td {
        height: 55px;
        position: relative;
        .el-checkbox {
          margin: 0 20px 0 5px;
        }
      }
      .td1 {
        display: flex;
        align-items: center;
        position: relative;
        .bad {
          position: absolute;
          left: 72px;
          top: 0px;
          height: 10px;
          width: 10px;
          background-color: red;
          border-radius: 50%;
        }
        img {
          height: 36px;
          width: 36px;
          margin-right: 18px;
          border-radius: 50%;
          border: 2px solid #3170ff;
        }
      }
      .td4 {
        display: flex;
        align-items: center;
        height: 55px;
        box-sizing: border-box;
        img {
          margin: 0 20px 0 30px;
          width: 40px;
          height: 20px;
        }
      }

      th,
      td {
        border-bottom: 1px solid #f0f0f0;
      }
      button {
        height: 40px;
        width: 80px;
        border-radius: 6px;
        border: 0;
        font-size: 14px;
      }
      .edit {
        margin-right: 15px;
        background: #3170ff;
        color: #fff;
      }
      .del {
        background: #f0f0f0;
        color: #333333;
      }
    }
  }
  .el-pagination {
    bottom: 70px;
  }
}
</style>